export const environment = {
  production: false,
  envType: 'DEVELOPMENT',
  isFullOnline: true,
  caisseApiUrl: 'https://devgestion.quiditmiam.fr/api',
  title: 'Caisse Collective - Développement',
  buildDate: "2026-09-02T10:37:53",
  lastPipeline: "6477",
  version: "0.0.0",
  sentryDsn: '',
};
